export const MAX_FILE_UPLOAD_SIZE_IN_BYTES=3000000
export const PASSPORT_SIZE_PHOT_DIMENSION_PIXEL=600
export const SIGNATURE_SIZE_PHOT_DIMENSION_PIXEL=300